import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCompanies', 'companies'),
  ...generateMutations('saveCompany', 'company'),
  ...generateMutations('getCompany', 'company'),
  ...generateMutations('deleteCompany'),
}
